export const getAdminUrl = () => {
  return window.location.origin.includes('dev-')
    ? window.location.origin.replace('outreach', 'admin')
    : window.location.origin.replace('outreach', 'uat-admin');
};
